import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';
import Logo from '../../../Royaltech_logo.png';
import { AuthContext } from '../../context/AuthContext';
import API_BASE_URL from '../../config/api';

interface NavbarProps {
  username?: string;
  showUserActions?: boolean;
}

export default function Navbar({ username, showUserActions = false }: NavbarProps) {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const [displayName, setDisplayName] = useState<string>('');

  // Note: role is available via localStorage.getItem('userRole') if needed

  useEffect(() => {
    const loadUsername = async () => {
      // Prefer explicit prop when present
      if (username && username.trim()) {
        const name = username.trim();
        setDisplayName(name);
        localStorage.setItem('username', name);
        return;
      }

      // Try to get from localStorage first
      const stored = (localStorage.getItem('username') || '').trim();
      if (stored && stored.toLowerCase() !== 'guest') {
        setDisplayName(stored);
        return;
      }

      // Try to get from AuthContext
      if (auth?.username) {
        setDisplayName(auth.username);
        localStorage.setItem('username', auth.username);
        return;
      }

      // Extract from token: token-username-company_id
      const token = (localStorage.getItem('token') || '').trim();
      if (token.startsWith('token-') && token.length > 6) {
        const tokenParts = token.substring(6).split('-'); // Remove 'token-' and split
        if (tokenParts.length > 0) {
          const derivedUsername = tokenParts[0]; // First part is username
          setDisplayName(derivedUsername);
          localStorage.setItem('username', derivedUsername);
          return;
        }
      }

      // Fallback: try to fetch from API
      try {
        const response = await fetch(`${API_BASE_URL}/user`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.username) {
            setDisplayName(data.username);
            localStorage.setItem('username', data.username);
            return;
          }
        }
      } catch (error) {
        console.error('Failed to fetch username:', error);
      }

      // No value available
      setDisplayName('');
    };

    loadUsername();
  }, [username, auth?.username]);

  const handleLogout = () => {
    // Use AuthContext logout function to properly clear all state
    auth?.logout();
    navigate('/login');
  };

  // const handleAdminPanel = () => navigate('/admin-panel');

  return (
    <nav className="w-full bg-white shadow-md px-6 py-4">
      <div className="flex justify-between items-center">
        <img 
          // src="https://static.readdy.ai/image/2ec7dc130a52c62101bb6f32cc87babe/d99b972dc62f270b2347c4c50836a1b4.png" 
          // alt="Docker Vision" 
          src={Logo} 
          alt="Royal Tech"  
          className="h-12 cursor-pointer"
          onClick={() => navigate('/home')}
        />
        
        {(showUserActions || displayName) && (
          <div className="flex items-center space-x-4">
            {displayName && (
              <span className="text-gray-700 font-medium">{displayName}</span>
            )}
            {showUserActions && (
              <Button variant="outline" onClick={handleLogout}>
                Logout
              </Button>
            )}
            {/* Admin Panel button removed here to avoid duplicate entry point on home */}
          </div>
        )}
      </div>
    </nav>
  );
}
